import { changeOrganizationMembersRoleBulkActionType } from '../../../../../../backend/features/organizations/shared';
import { useContactManagementTranslation } from '../../../../../../ui/hooks/useContactManagementTranslation';
import { getFilterForBulkAction } from '../../../../../../utils';
import { handleErrorDialog, showConfirmDialog, showCustomDialog } from '@juvare/common-web-ui/DialogHelper';
import { launchBulkAction } from '@juvare/platform-sdk-react/ui/features/bulk-actions';
import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { Button, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { OrganizationRoleOrStatusRadioGroup } from './OrganizationRoleOrStatusRadioGroup';
export function showChangeOrganizationMemberRoleDialog(params) {
    showCustomDialog({
        fullWidth: true,
        maxWidth: 'sm',
        content: (close) => React.createElement(OrganizationMemberRoleDialog, Object.assign({}, params, { close: close })),
    });
}
const OrganizationMemberRoleDialog = (props) => {
    const settings = useSelector(getSettings);
    const { orgStatusMap, orgRoleMap } = settings;
    const { t } = useContactManagementTranslation();
    const [selectedRole, setSelectedRole] = React.useState();
    const selectedCount = props.selectedAccountIds.length > 0 ? props.selectedAccountIds.length : props.filteredRowCount;
    const handleChange = (event) => {
        setSelectedRole(event.target.value);
    };
    const handleChangeRole = () => {
        try {
            launchBulkAction({
                type: changeOrganizationMembersRoleBulkActionType,
                title: t('forms.orgMembers.applyingBulkChanges'),
                params: {
                    organizationId: props.organizationId,
                    newRole: selectedRole,
                    filter: getFilterForBulkAction(props.selectedAccountIds, props.appliedStorageFilters),
                },
                onClose: () => {
                    props.onAfterSave();
                    props.close();
                },
            });
        }
        catch (error) {
            handleErrorDialog(error);
        }
    };
    const handleSave = () => {
        if (selectedRole) {
            const statusesRequiringRoles = Object.values(orgStatusMap)
                .filter((s) => s.requireOrgRole)
                .map((s) => `"${s.label}"`);
            showConfirmDialog({
                title: t('forms.orgMembers.changeRole'),
                content: (React.createElement(React.Fragment, null,
                    React.createElement(Typography, null, t('forms.orgMembers.changeRoleQuestion', { count: selectedCount })),
                    React.createElement(Typography, null, t('forms.orgMembers.changeRoleNote', {
                        statuses: statusesRequiringRoles.join(', '),
                        count: statusesRequiringRoles.length,
                    })),
                    React.createElement(Typography, null, t('panels.accounts.currentUserNotChangedRole')))),
                onConfirm: () => handleChangeRole(),
            });
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DialogTitle, null, t('forms.orgMembers.changeRoleOfAccount', { count: selectedCount })),
        React.createElement(DialogContent, null,
            React.createElement(OrganizationRoleOrStatusRadioGroup, { items: orgRoleMap, selected: selectedRole, handleChange: handleChange, dataTestPrefix: 'role' })),
        React.createElement(DialogActions, null,
            React.createElement(Button, { color: 'primary', onClick: () => props.close(), "data-test": 'cancel-button' }, t('common.cancel')),
            React.createElement(Button, { color: 'primary', disabled: !selectedRole, onClick: handleSave, "data-test": 'save-button' }, t('common.save')))));
};
